import i18next from 'i18next';

i18next.addResources('en', 'BottleSocials', {
  importantInfo: 'Our whisky is always unchill-filtered\nand bottled at its natural colour. ',
  weAreSocial: "We're social,\nconnect with us"
});

i18next.addResources('fr', 'BottleSocials', {
  importantInfo: 'Notre whisky n’est jamais filtré à froid \net aucun colorant n’y est ajouté. ',
  weAreSocial: 'Nous sommes sur les réseaux sociaux,\nconnectez-vous avec nous !'
});

i18next.addResources('it', 'BottleSocials', {
  importantInfo: 'Il nostro whisky non è mai filtrato a freddo,\nné è stato aggiunto alcun colorante. ',
  weAreSocial: 'Siamo social,\nconnettiti con noi!'
});

i18next.addResources('de', 'BottleSocials', {
  importantInfo: 'Unser Whisky wird immer ungekühlt gefiltert und mit seiner natürlichen Farbe abgefüllt.',
  weAreSocial: 'Wir sind sozial,\nverbinden Sie sich mit uns'
});

i18next.addResources('zh', 'BottleSocials', {
  importantInfo: '我们的威士忌坚持不使用冷凝过滤也不添加焦糖着色剂 ',
  weAreSocial: '欢迎关注我们'
});

i18next.addResources('zt', 'BottleSocials', {
  importantInfo: '我們的威士忌堅持不使用冷凝過濾也不添加焦糖著色劑 ',
  weAreSocial: '歡迎追蹤我們'
});

i18next.addResources('es', 'BottleSocials', {
  importantInfo: 'Nuestro whisky siempre se filtra sin enfriar\ny se embotella en su color natural. ',
  weAreSocial: 'Somos sociales,\nconéctate con nosotros'
});

i18next.addResources('pt', 'BottleSocials', {
  importantInfo: 'Nosso whisky sempre é filtrado sem resfriamento\ne engarrafado em sua cor natural. ',
  weAreSocial: 'Somos sociais,\nconecte-se conosco'
});

i18next.addResources('ja', 'BottleSocials', {
  importantInfo: '私たちのウイスキーは常に非冷却濾過され\n自然な色でボトル詰めされています。 ',
  weAreSocial: '私たちはソーシャルです、\n私たちとつながりましょう'
});

i18next.addResources('ru', 'BottleSocials', {
  importantInfo:
    'Наш виски всегда фильтруется без охлаждения\nи разливается в бутылки в своем естественном цвете. ',
  weAreSocial: 'Мы в социальных сетях,\nсвяжитесь с нами'
});

i18next.addResources('ar', 'BottleSocials', {
  importantInfo: 'ويسكينا دائماً غير مبرد التصفية\nومعبأ بلونه الطبيعي. ',
  weAreSocial: 'نحن اجتماعيون،\nتواصل معنا'
});

i18next.addResources('hi', 'BottleSocials', {
  importantInfo: 'हमारी व्हिस्की हमेशा अनचिल-फ़िल्टर्ड होती है\nऔर अपने प्राकृतिक रंग में बोतलबंद होती है। ',
  weAreSocial: 'हम सामाजिक हैं,\nहमसे जुड़ें'
});
